import { ApiService } from "./ApiService";
import { ApiUrl } from "./ApiUrl";
import qs from "qs";

const URL_API = ApiUrl.VACACIONES;

const VacacionesService = {
  async listar() {
    const respuesta = await ApiService(URL_API).get("/control-vacacional");
    return respuesta.data;
  },
  async listarConPaginacion(params) {
    const respuesta = await ApiService(URL_API).get("/control-vacacional/listar-con-paginacion", {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    return respuesta.data;
  },
  async calcular(data) {
    const respuesta = await ApiService(URL_API).post("/calcular", data);
    return respuesta.data;
  },
  async descargarReporteExcel(params) {
    const respuesta = await ApiService(URL_API).get("/control-vacacional/descargarReporteExcel", {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },

      responseType: "blob",

    });
    return respuesta;
  },

  async descargarReporteExcelSolicitudes(params) {
    const respuesta = await ApiService(URL_API).get("/control-vacacional/descargarReporteExcelSolicitudes", {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },

      responseType: "blob",

    });
    return respuesta;
  },

  async simularDescontarDias(body) {
    const respuesta = await ApiService(URL_API).post("/control-vacacional/simular-descontar-dias", body);
    return respuesta.data;
  },

};

const SolicitudAusenciaService = {
  async listarPorGestionHumana(params) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana", {
      params: params,
    });
    return respuesta.data;
  },

  async listarPorGestionHumanaConPaginacion(params) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana/listar-con-paginacion", {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    return respuesta.data;
  },

  async aprobarPorGestionHumana(body) {
    const respuesta = await ApiService(URL_API).post("/solicitud/gestionhumana/aprobar", body);
    return respuesta.data;
  },

  async rechazarPorGestionHumana(body) {
    const respuesta = await ApiService(URL_API).post("/solicitud/gestionhumana/rechazar", body);
    return respuesta.data;
  },

  async getUrlDocumento(empresaId, solicitudId, plataforma) {
    const respuesta = await ApiService(URL_API).get(`/solicitud/gestionhumana/solicitudId/${solicitudId}/empresa/${empresaId}/plataforma/${plataforma}/url`);
    return respuesta.data;
  },

  async agregarSeguimiento(body) {
    const respuesta = await ApiService(URL_API).post("/solicitud/gestionhumana/seguimiento", body);
    return respuesta.data;
  },

  async getUrlSeguimiento(empresaId, solicitudId, plataforma, seguimientoId) {
    const respuesta = await ApiService(URL_API).get(`/solicitud/gestionhumana/solicitudId/${solicitudId}/empresa/${empresaId}/plataforma/${plataforma}/seguimientoId/${seguimientoId}/url`);
    return respuesta.data;
  },

  async buscarPorId(solicitudAusenciaId) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana/" + solicitudAusenciaId);
    return respuesta.data;
  },

  async agregarAltaMedica(body) {
    const respuesta = await ApiService(URL_API).post("solicitud/gestionhumana/altaMedica", body);
    return respuesta.data;
  },

  async getUrlAltaMedica(solicitudId, plataforma) {
    const respuesta = await ApiService(URL_API).get(`/solicitud/gestionhumana/solicitudId/${solicitudId}/plataforma/${plataforma}/url`);
    return respuesta.data;
  },

  async getUrlsAdjuntos(solicitudId) {
    const respuesta = await ApiService(URL_API).get(`/solicitud/gestionhumana/solicitudId/${solicitudId}/url`);
    return respuesta.data;
  },

  async getCalendario(params) {
    const respuesta = await ApiService(URL_API).get(`/solicitud/calendario`, {
      params: params,
    });
    return respuesta.data;
  },

  async descargarReporteExcelSolicitudes(params) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana/descargarReporteExcelSolicitudesAusencia", {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      responseType: "blob",
    });
    return respuesta;
  },

  async descargarReporteExcelPCA(params, formato = "xlsx") {
    const ruta = formato === "csv" ? "descargarReporteCsvPCA" : "descargarReporteExcelPCA";
    const respuesta = await ApiService(URL_API).get(`/solicitud/gestionhumana/${ruta}`, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      responseType: "blob",
    });
    return respuesta;
  },

  async notificarDocumento(body) {
    const respuesta = await ApiService(URL_API).post("/solicitud/gestionhumana/notificar-documento-antes-aprobar", body);
    return respuesta.data;
  },

  async solicitarAusenciasFromAdmin(body) {
    const respuesta = await ApiService(URL_API).post("/solicitud/solicitarAusenciasFromAdmin", body);
    return respuesta.data;
  },

  async cancelarSolicitudFromAdmin(body) {
    const respuesta = await ApiService(URL_API).post("/solicitud/solicitudPersonal/admin/cancelar", body);
    return respuesta.data;
  },

  // En VacacionesService o SolicitudAusenciaService
  async eliminarVacaciones(solicitudId) {
    const respuesta = await ApiService(URL_API).delete(`/solicitud/gestionhumana/eliminar/${solicitudId}`);
    return respuesta.data;
  },

  async eliminarSolicitudPorAdmin(solicitudId) {
    const respuesta = await ApiService(URL_API).delete(`/solicitud/gestionhumana/eliminar-solicitud/${solicitudId}`);
    // El backend siempre responde HTTP 200, incluso en errores de negocio (ApiResponse.error()
    // también arma un 200) -- hay que inspeccionar el body para no reportar éxito en un rechazo.
    if (respuesta.data?.estado === "ERROR") {
      const error = new Error(respuesta.data?.mensaje || "Error al eliminar la solicitud");
      error.response = respuesta;
      throw error;
    }
    return respuesta.data;
  },

  // SDF/SDF Energía: reintento manual de generar el convenio de fraccionamiento/adelanto cuando los dos
  // intentos automáticos (al crear la solicitud y al aprobar el último nivel) fallaron.
  async regenerarConvenio(solicitudId) {
    const respuesta = await ApiService(URL_API).post(`/solicitud/gestionhumana/regenerar-convenio/${solicitudId}`);
    if (respuesta.data?.estado === "ERROR") {
      const error = new Error(respuesta.data?.mensaje || "Error al regenerar el convenio");
      error.response = respuesta;
      throw error;
    }
    return respuesta.data;
  },
};

const CargarHistoricoVacacionesService = {
  async cargar(body) {
    const respuesta = await ApiService(URL_API).post("/historico", body);
    return respuesta.data;
  },
};

const TiposAusenciaService = {
  async listar() {
    const respuesta = await ApiService(URL_API).get("/tipos");
    return respuesta.data;
  },

};

const ReglasVacacionesService = {
  async listar() {
    const respuesta = await ApiService(URL_API).get("/reglas");
    return respuesta.data;
  },
  async listarFiltros(params) {
    const respuesta = await ApiService(URL_API).get("/reglas/filtro", {
      params: params
    });
    return respuesta.data;
  },
  async actualizarFiltro(data) {
    const respuesta = await ApiService(URL_API).put("/reglas/filtro", data);
    return respuesta.data;
  },
};

const BloqueoMovimientosService = {
  async obtener() {
    const respuesta = await ApiService(URL_API).get("/bloqueo-movimientos");
    return respuesta.data;
  },
  async actualizar(data) {
    const respuesta = await ApiService(URL_API).put("/bloqueo-movimientos", data);
    return respuesta.data;
  },
};

const AusenciaService = {
  async importar(data) {
    const respuesta = await ApiService(URL_API).post("/ausencia/importar", data);
    return respuesta.data;
  },
}

const ProgramacionService = {
  async listar(params) {
    const respuesta = await ApiService(URL_API).get("/programacion/listar", { params });
    return respuesta.data;
  },
  async importar(data) {
    const respuesta = await ApiService(URL_API).post("/programacion/importar", data, {
      responseType: "blob",
    });
    const contentType = respuesta.headers["content-type"] || "";
    if (contentType.includes("spreadsheetml") || contentType.includes("excel")) {
      return { esArchivo: true, blob: respuesta.data };
    }
    // Es JSON — parsear desde blob
    const text = await respuesta.data.text();
    return JSON.parse(text);
  },
  async editar(id, data) {
    const respuesta = await ApiService(URL_API).put(`/programacion/${id}`, data);
    return respuesta.data;
  },
  async cancelar(id) {
    const respuesta = await ApiService(URL_API).put(`/programacion/${id}/cancelar`);
    return respuesta.data;
  },
  async aprobar(data) {
    const respuesta = await ApiService(URL_API).post("/programacion/aprobar", data);
    return respuesta.data;
  },
  async anular(id) {
    const respuesta = await ApiService(URL_API).put(`/programacion/${id}/anular`);
    return respuesta.data;
  },
  async eliminar(id) {
    const respuesta = await ApiService(URL_API).delete(`/programacion/${id}`);
    return respuesta.data;
  },
};

const CompraVacacionesService = {
  async listar(params) {
    const respuesta = await ApiService(URL_API).get("/compra/listar", { params });
    return respuesta.data;
  },
  async importar(data) {
    const respuesta = await ApiService(URL_API).post("/compra/importar", data, {
      responseType: "blob",
    });
    const contentType = respuesta.headers["content-type"] || "";
    if (contentType.includes("spreadsheetml") || contentType.includes("excel")) {
      return { esArchivo: true, blob: respuesta.data };
    }
    // Es JSON — parsear desde blob
    const text = await respuesta.data.text();
    return JSON.parse(text);
  },
  async editar(id, data) {
    const respuesta = await ApiService(URL_API).put(`/compra/${id}`, data);
    return respuesta.data;
  },
  async cancelar(id) {
    const respuesta = await ApiService(URL_API).put(`/compra/${id}/cancelar`);
    return respuesta.data;
  },
  async aprobar(data) {
    const respuesta = await ApiService(URL_API).post("/compra/aprobar", data);
    return respuesta.data;
  },
  async anular(id) {
    const respuesta = await ApiService(URL_API).put(`/compra/${id}/anular`);
    return respuesta.data;
  },
};

const HistoricoDescansoMedicoService = {
  async cargar(archivo) {
    const formData = new FormData();
    formData.append("archivo", archivo);
    const respuesta = await ApiService(URL_API).post(
      "/solicitud/gestionhumana/historico-descanso-medico",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return respuesta.data;
  },
  async listar(params) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana/historico-descanso-medico", { params });
    return respuesta.data;
  },
  async resumen(params) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana/historico-descanso-medico/resumen", { params });
    return respuesta.data;
  },
  async detalle(params) {
    const respuesta = await ApiService(URL_API).get("/solicitud/gestionhumana/historico-descanso-medico/detalle", { params });
    return respuesta.data;
  },
};

export {
  AusenciaService,
  BloqueoMovimientosService,
  HistoricoDescansoMedicoService,
  ProgramacionService,
  CompraVacacionesService,
  ReglasVacacionesService,
  VacacionesService,
  SolicitudAusenciaService,
  CargarHistoricoVacacionesService,
  TiposAusenciaService
};
